export const SET_EMAIL_ACTION = 'login/SET_EMAIL_ACTION'
export const SET_PASSWORD_ACTION = 'login/SET_PASSWORD_ACTION'
export const IS_LOGIN_LOADING_ACTION = 'login/IS_LOGIN_LOADING_ACTION'
export const HAS_LOGIN_ACTION = 'login/HAS_LOGIN_ACTION'
export const USER_DATA_ACTION = 'login/USER_DATA_ACTION'
export const SET_PAGE_SHOW_ACTION = 'login/SET_PAGE_SHOW_ACTION'
export const SET_REGISTER_NICKNAME = 'login/SET_REGISTER_NICKNAME'
export const SET_REGISTER_EMAIL = 'login/SET_REGISTER_EMAIL'
export const SET_REGISTER_PASSWORD = 'login/SET_REGISTER_PASSWORD'
export const SET_REGISTER_SECOND_PASSWORD = 'login/SET_REGISTER_SECOND_PASSWORD'